// TODO VISHAL (change this to one click)
export const GBX_ANALYTICS_LABELS = {
  VIEWED_LANDING_PAGE: 'Viewed GBX Upgrade Landing Page',
  CLICKED_CROSS: 'Clicked X on GBX Upgrade Landing Page',
  CLICKED_CONFIRMED: 'Clicked confirmed on GBX Upgrade Landing Page',
  CLICKED_LEARN_MORE: 'Clicked Learn more link on GBX Upgrade Landing Page',
  VIEWED_LEARN_MORE: 'Viewed GBX Learn More overlay',
  CLOSED_LEARN_MORE: 'Clicked Okay on GBX Learn More overlay',
  SUCCESS: 'Successfully upgraded to GBX',
  FAILED: 'Error while upgrading to GBX',
  NO_THANKS: 'Clicked no thanks on GBX Upgrade Landing Page',
  DETRACTOR_V1: 'detractors from V1',
};

export const DEFAULT_ERROR_MESSAGE =
  'Sorry, something went wrong. Please try again or contact IPSYCare';

export const NO_PAYMENT_METHOD_ERROR_MESSAGE = '[no payment information]';

export const GBX_UPGRADE_LANDING_ANALYTICS_LABELS = {
  VIEWED: 'Viewed GBX Upgrade Landing Page',
  CLICKED_CROSS: 'Clicked X on GBX Upgrade Landing Page',
  CLICKED_IPSY_LOGO: 'Clicked IPSY icon on GBX Upgrade Landing Page',
  CLICKED_RESERVED_SPOT: 'Clicked reserve spot on GBX Upgrade Landing Page',
  CLICKED_LEARN_MORE: 'Clicked Learn more link on GBX Upgrade Landing Page',
  VIEWED_LEARN_MORE:
    'Viewed GBX Learn More overlay on GBX Upgrade Landing Page',
  CLOSED_LEARN_MORE:
    'Clicked Okay on GBX Learn More overlay on GBX Upgrade Landing Page',
};

export const GBX_UPGRADE_CHECKOUT_ANALYTICS_LABELS = {
  VIEWED: 'Viewed GBX Upgrade Checkout Page',
  CLICKED_CROSS: 'Clicked X on GBX Upgrade Checkout Page',
  CLICKED_IPSY_LOGO: 'Clicked IPSY icon on GBX Upgrade Checkout Page',
  CLICKED_CONFIRMED: 'Clicked confirm on GBX Upgrade Checkout Page',
  CLICKED_LEARN_MORE: 'Clicked Learn more link on GBX Upgrade Checkout Page',
  VIEWED_LEARN_MORE:
    'Viewed GBX Learn More overlay on GBX Upgrade Checkout Page',
  CLOSED_LEARN_MORE:
    'Clicked Okay on GBX Learn More overlay on GBX Upgrade Checkout Page',
  SUCCESS: 'Successfully upgraded to GBX - Checkout Page',
  FAILED: 'Error while upgrading to GBX - Checkout Page',
};
